import { shippingTypes } from '~/utils/constants'

const shippingType = {
  hasFares: ({ slug }) => slug === shippingTypes.MIENVIO,
}

export default shippingType
